module.exports = __webpack_public_path__ + "static/media/hazelnuts.e7eba793.svg";